import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/InvoiceForm.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReduxProvider"] */ "/opt/buildhome/repo/src/redux/Provider.jsx");
